const rawBaseURL = process.env.NEXT_PUBLIC_BASE_URL;

if (!rawBaseURL || rawBaseURL.trim() === "") {
  throw new Error(
    "NEXT_PUBLIC_BASE_URL is required. Please set it in your environment variables or build arguments."
  );
}

let parsedURL: URL;
try {
  parsedURL = new URL(rawBaseURL);
} catch {
  throw new Error(
    `NEXT_PUBLIC_BASE_URL must be a valid absolute URL starting with http:// or https://. Received: "${rawBaseURL}"`
  );
}

if (!["http:", "https:"].includes(parsedURL.protocol)) {
  throw new Error(
    `NEXT_PUBLIC_BASE_URL protocol must be http: or https:. Received: "${parsedURL.protocol}"`
  );
}

// Normalize trailing slashes first
const normalizedURL = rawBaseURL.replace(/\/+$/, "");

// Strict validation ensuring the variable ends in /api/v1
if (!/\/api\/v1$/.test(normalizedURL)) {
  throw new Error(
    `NEXT_PUBLIC_BASE_URL must end with "/api/v1". Received: "${rawBaseURL}"`
  );
}

export const API_BASE_URL = normalizedURL;

// Remove /api/v1 suffix if present, otherwise use full URL
export const BACKEND_BASE_URL = API_BASE_URL.replace(/\/api\/v1\/?$/i, "");
